export let appPeople = "OmoxS";
export default {appPeople};